import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { DefaultDrawContribution } from "./draw-contribution";

import { DefaultCanvasGroupRender } from "./group-render";

import { DefaultIncrementalDrawContribution } from "./incremental-draw-contribution";

import { DrawContribution, GraphicRender, GroupRender, IncrementalDrawContribution } from "./symbol";

import { CommonDrawItemInterceptorContribution, DrawItemInterceptor } from "./draw-interceptor";

import { GroupRenderContribution, InteractiveSubRenderContribution } from "./contributions/constants";

import { DefaultBaseBackgroundRenderContribution, DefaultBaseInteractiveRenderContribution, DefaultBaseTextureRenderContribution } from "./contributions";

export function bindRenderModules({bind: bind}) {
    bind(DefaultBaseBackgroundRenderContribution).toSelf().inSingletonScope(), bind(DefaultBaseTextureRenderContribution).toSelf().inSingletonScope(), 
    bind(DrawContribution).to(DefaultDrawContribution), bind(IncrementalDrawContribution).to(DefaultIncrementalDrawContribution), 
    bind(GroupRender).toDynamicValue((({container: container}) => new DefaultCanvasGroupRender(createContributionProvider(GroupRenderContribution, container)))).inSingletonScope(), 
    bind(GraphicRender).toService(GroupRender), bindContributionProvider(bind, GroupRenderContribution), 
    bindContributionProvider(bind, InteractiveSubRenderContribution), bind(DefaultBaseInteractiveRenderContribution).toDynamicValue((({container: container}) => new DefaultBaseInteractiveRenderContribution(createContributionProvider(InteractiveSubRenderContribution, container)))).inSingletonScope(), 
    bindContributionProvider(bind, GraphicRender), bind(CommonDrawItemInterceptorContribution).toSelf().inSingletonScope(), 
    bind(DrawItemInterceptor).toService(CommonDrawItemInterceptorContribution), bindContributionProvider(bind, DrawItemInterceptor);
}

export default bindRenderModules;
//# sourceMappingURL=module.js.map
